<article class="bleachr-card standalone-card" (click)="buildURL($event, card.data[0].url)" [attr.bleachr-route]="card.data[0].url" [style.aspectRatio]="aspect_ratio">
  <!-- HEADER -->
  <div class="bleachr-card-headline" [style.background-image]="handleGradient()">
    @if (card.context.headline_icon) {
      <div style="display: flex; height: inherit">
        <div class="icon-container padded">
          <img [src]="cloudinaryCacheImage(card.context.headline_icon)" alt="" style="height: 100%; object-fit: cover" />
        </div>
      </div>
    }
    <div class="headline-text-container" [ngStyle]="card.context.headline_icon ? { 'padding-left': 0 } : {}">
      <div class="truncate" [style.color]="card.title_color">
        {{ card.title }}
      </div>
      @if (card.subtitle) {
        <div class="truncate sub-title" [style.color]="card.subtitle_color">
          {{ card.subtitle }}
        </div>
      }
    </div>
  </div>
  <!-- CONTENT -->
  <div class="content-container">
    @if (isVideo) {
      <app-media-chrome-player [src]="videoSources"></app-media-chrome-player>
    }
    <!-- <app-plyr *ngIf="isVideo" [plyrSources]="videoSources" [plyrOptions]="options" (plyrInit)="plyrInit($event)"></app-plyr> -->
    @if (card.context.display_tap_indicator) {
      <img
        class="display-tap-indicator"
        src="https://res.cloudinary.com/bleachr/image/upload/v1652118759/TennisONE/T1%20Icons/click_tap4.png"
        alt=""
        />
    }
    @if (!isVideo) {
      <img [src]="card.data[0].photo_url" [alt]="card.title" />
    }
  </div>
  <!-- FOOTER -->
  <footer class="bleachr-card-footer">
    @if (card.see_all) {
      <h5 [style.color]="card.see_all_color">
        {{ card.see_all }}
      </h5>
    }
    @if (card.data[0].text) {
      <div>
        <p class="body-text" [style.color]="card.body_color">
          {{ card.data[0].text | clipContent: 45 }}
        </p>
      </div>
    }
  </footer>
</article>
